module.exports = __webpack_public_path__ + "img/gallery-9.69e36fd0.jpg";